import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { BILLING_BASE_URL } from '@ctct/infrastructure-layer';
import { observabilityAppService } from '@ctct/myaccount-utils-static';
import { useIsRedirectFromSecureEnabled, useSecureAppBlock } from '@ctct/state-server-layer';

interface RedirectToBillingAppProps {
  children: React.ReactNode;
}

const SECURE_APP_BLOCK_MESSAGE = 'Secure app block: redirecting to billing app';

export const RedirectToBillingApp = ({ children }: RedirectToBillingAppProps) => {
  const location = useLocation();
  const isSecureAppBlock = useSecureAppBlock();
  const { data: isRedirectFromSecureEnabled, isLoading: isRedirectFromSecureLoading } =
    useIsRedirectFromSecureEnabled();

  const shouldRedirect = isSecureAppBlock || isRedirectFromSecureEnabled;

  useEffect(() => {
    if (!shouldRedirect) return;

    if (isSecureAppBlock) {
      try {
        observabilityAppService.notify(new Error(SECURE_APP_BLOCK_MESSAGE), {
          referrer: document.referrer || undefined,
          pathname: location.pathname,
          search: location.search,
        });
      } catch {
        // Ensure redirect still happens if logging fails
      }
    }

    const billingAppUrl = `${BILLING_BASE_URL}${location.pathname}${location.search}`;

    window.location.href = billingAppUrl;
  }, [shouldRedirect, isSecureAppBlock, location.pathname, location.search]);

  if (isSecureAppBlock) {
    return null;
  }

  if (isRedirectFromSecureLoading) {
    return null;
  }

  if (isRedirectFromSecureEnabled) {
    return null;
  }

  return children;
};
